$(function () {
  console.log('test121233')
  $('#createPdfForm').submit(function (e) {
    var canvas = document.getElementById("myChart");
    var image = canvas.toDataURL("image/png");
    var form = $(this);

    $('input[name="image"]').val(image)


    // $('.date').map(function (datepicker) {
    //   console.log($('.date'));
    //
    // })
    // console.log(image);

    // e.preventDefault();
    // return false;
  })
});